export default function getTranslation(value, language) {
    try {
        return translations[value][language]
    } catch (error) {
        return value
    }
}
export const translations = {
    "permalink": {
        pl: 'Permalink',
        en: '',
    },
    "id": {
        pl: 'Id',
        en: '',
    },
    "nr_pkbwl": {
        pl: 'NR PKBWL',
        en: 'OCCURRENCE REF',
    },
    "klasyfikacja_zdarzenia": {
        pl: 'KLASYFIKACJA ZDARZENIA',
        en: 'OCCURRENCE CLASS',
    },
    "data_zdarzenia": {
        pl: 'DATA ZDARZENIA',
        en: 'DATE OF OCCURRENCE',
    },
    "godzina_zdarzenia": {
        pl: 'CZAS ZDARZENIA (LMT)',
        en: '',
    },
    "miejsce_zdarzenia": {
        pl: 'MIEJSCE ZDARZENIA',
        en: 'OCCURRENCE PLACE',
    },
    "kategoria_statku_powietrznego": {
        pl: 'KATEGORIA STATKU POWIETRZNEGO',
        en: 'AIRCRAFT CATEGORY',
    },
    "typ_statku_powietrznego": {
        pl: 'TYP STATKU POWIETRZNEGO',
        en: 'AIRCRAFT TYPE',
    },
    "znaki_rozpoznawcze": {
        pl: 'ZNAKI ROZPOZNAWCZE',
        en: 'AIRCRAFT REGISTRATION MARKS',
    },
    "raport_wstepny": {
        pl: 'RAPORT WSTĘPNY',
        en: 'PRELIMINARY REPORT',
    },
    "uchwala": {
        pl: 'UCHWAŁA',
        en: 'RESOLUTION',
    },
    "raport_koncowy": {
        pl: 'RAPORT KOŃCOWY',
        en: 'FINAL REPORT',
    },
    "zalecenia_bezpieczenstwa": {
        pl: 'ZALECENIA BEZPIECZEŃSTWA',
        en: 'SAFETY RECOMMENDATIONS',
    },
    "status_badania": {
        pl: 'STATUS BADANIA',
        en: '',
    },
    "data_zakonczenia_badania": {
        pl: 'DATA ZAKOŃCZENIA BADANIA',
        en: 'DATE OF COMPLETION OF THE INVESTIGATION',
    },
    "numer_eccairs": {
        pl: 'NUMER ECCAIRS',
        en: '',
    },
    'operator_statku_powietrznego': {
        pl: 'OPERATOR/UŻYTKOWNIK STATKU POWIETRZNEGO',
        en: '',
    },
    'masa_mtow_statku_powietrznego': {
        pl: 'MASA STATKU POWIETRZNEGO',
        en: 'MTOW',
    },
    'poziom_obrazen': {
        pl: 'POZIOM OBRAŻEŃ',
        en: '',
    },
    '   podmiot_badajacy': {
        pl: 'PODMIOT BADAJĄCY',
        en: '',
    },
    'oswiadczenie_tymczasowe': {
        pl: 'OŚWIADCZENIE TYMCZASOWE',
        en: '',
    },
    'przebieg_badania': {
        pl: 'PRZEBIEG BADANIA',
        en: '',
    },
    'sklad_zespolu_badawczego': {
        pl: 'SKŁAD ZESPOŁU BADAWCZEGO',
        en: '',
    },
    'kategoria_zdarzenia': {
        pl: 'KATEGORIA ZDARZENIA',
        en: '',
    },
    'dodatkowe_uwagi': {
        pl: 'DODATKOWE UWAGI',
        en: '',
    },
    'accrep': {
        pl: 'ACCREP',
        en: '',
    },
    'rodzaj_operacji': {
        pl: 'RODZAJ OPERACJI',
        en: '',
    },
    'kategoria_raportu': {
        pl: 'KATEGORIA RAPORTU',
        en: '',
    },
    'podmiot_badajacy': {
        pl: 'PODMIOT BADAJĄCY',
        en: '',
    },
    'osoba_badajaca_lub_nadzorujaca_badanie':{
        pl: 'OSOBA NADZORUJĄCA BADANIE',
        en: '',
    },
    'osoba_badajaca_lub_nadzorujaca_zdarzenie':{
        pl: 'OSOBA NADZORUJĄCA BADANIE',
        en: '',
    },
}